// While the page is being scrolled, decorative motion holds still.
// Sets <html data-scrolling="1"> during scroll/touchmove/wheel and clears it
// 200 ms after the last one; index.css pauses CSS animations under it, and the
// particle canvas and parallax skip frames (isScrolling()). Measured on a
// throttled Pixel 7 profile: median frame 33 ms → 16.7 ms while scrolling.
const SETTLE_MS = 200;
let timer = null;
let installed = false;

export function isScrolling() {
    return typeof document !== 'undefined' && document.documentElement.dataset.scrolling === '1';
}

function settle() {
    timer = null;
    delete document.documentElement.dataset.scrolling;
}

function onMove() {
    if (!isScrolling()) document.documentElement.dataset.scrolling = '1';
    clearTimeout(timer);
    timer = setTimeout(settle, SETTLE_MS);
}

export function installScrollCalm() {
    if (installed || typeof window === 'undefined') return;
    installed = true;
    const opts = { passive: true, capture: true };
    window.addEventListener('scroll', onMove, opts);
    window.addEventListener('touchmove', onMove, opts);
    window.addEventListener('wheel', onMove, opts);
}
